import { render, staticRenderFns } from "./TreatmentShow.vue?vue&type=template&id=4c148191&scoped=true&"
import script from "./TreatmentShow.vue?vue&type=script&lang=js&"
export * from "./TreatmentShow.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentShow.vue?vue&type=style&index=0&id=4c148191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c148191",
  null
  
)

export default component.exports